import { render, staticRenderFns } from "./BuyBox.vue?vue&type=template&id=2eb72b78&scoped=true"
import script from "./BuyBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BuyBox.vue?vue&type=style&index=0&id=2eb72b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb72b78",
  null
  
)

export default component.exports